exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-node-trigger[data-v-6c5f4278]{padding:.75rem;outline:2px solid rgba(var(--fts-primary-rgb),.3)}", ""]);

// exports
